<h2>My Companies</h2>

<ul class="companies">
    <li *ngFor ="let company of companies">
        <a routerLink="/detail/{{company.id}}">
            <span class="badge">{{company.id}}</span> {{company.name}}
        </a>
    </li>
</ul>
